<template>
    <div class="main">
        <c-panel>
            <form-livro :paramId="$route.params.id" v-on:onSubmitLivro="onSubmitLivro"></form-livro>
        </c-panel>
    </div>
</template>
<script>
import formLivro from "./form"

export default {
    methods:{
        onSubmitLivro(){
            this.$router.push('/admin/biblioteca/livro');
        }
    },
    components:{ formLivro }
}
</script>

